export default {
  path: "/SectionContent/Codes",
  name: "Georgia Codes",
  htmlContent: "commercial_motor_vehicles.html",
  headings: [],
};
